module.exports = __webpack_public_path__ + "img/as-taco.c70cf6e6.svg";